import { useEffect, useState } from 'react';
import {
  Box, Button, Dialog, DialogTitle, DialogContent,
  TextField,
  Typography, Checkbox, CircularProgress, IconButton, Grid,
  DialogActions,
  Card,
  CardHeader,
  Tooltip,
} from '@mui/material';
import { privateAxios } from '../../../config/apiConfig';
import { toast } from 'react-toastify';
import { DataGrid } from '@mui/x-data-grid';
import { Add, Delete, Edit, FileDownload, PictureAsPdf, Print, Visibility } from '@mui/icons-material';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import { PermissionService } from '../../../config/permissionService';
import { getSelectedExportRows } from "../../../config/exportSelection";


const AddGroupMap = () => {
  const token = localStorage.getItem('jwt');
  const headers = { Authorization: `Bearer ${token}` };
  const [groupName, setGroupName] = useState("");
  const [permissions, setPermissions] = useState([]);
  const [selected, setSelected] = useState({}); // { featureId: [permissionIds...] }
  const [employeeIds, setEmployeeIds] = useState([]);
  const [users, setUsers] = useState([]);
  const [categories, setCategories] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [groupsLoading, setGroupsLoading] = useState(false);
  const [groupMaps, setGroupMaps] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [viewOpen, setViewOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [editGroupId, setEditGroupId] = useState(null);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [searchText, setSearchText] = useState("");

  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [assignEmployee, setAssignEmployee] = useState(false);


  useEffect(() => {
    privateAxios.get('admin/employees', { headers })
      .then(res => { setUsers(res.data.response.filter(e => e.enabled) || []); });

    privateAxios.get('admin/features/permissions', { headers }).then((res) => {
      // normalize data to always be an array
      setPermissions(res.data?.response);
    });

    privateAxios.get('admin/features', { headers })
      .then(res => {
        if (res?.data?.status === "SUCCESS") {
          setCategories(res.data.response.filter(f => f.category !== "Employee") || []);
        }
      });
    fetchGroupMaps();
  }, []);


  const fetchGroupMaps = () => {
    setGroupsLoading(true);

    privateAxios
      .get("admin/group-maps", { headers })
      .then((res) => {
        if (Array.isArray(res.data)) {
          setGroupMaps(res.data);
        } else {
          setGroupMaps([]); // fallback in case response is not an array
        }
        console.log("all grp", res.data);
      })
      .catch((err) => {
        console.error("Failed to fetch group maps:", err);
        setGroupMaps([]); // prevent screen crash if API fails
      })
      .finally(() => {
        setGroupsLoading(false); // stop loader in both success/failure
      });
  };


  const handleCheckboxChange = (featureId, permissionId) => {
    setSelected((prev) => {
      const current = prev[featureId] || [];
      if (current.includes(permissionId)) {
        return { ...prev, [featureId]: current.filter((id) => id !== permissionId) };
      } else {
        return { ...prev, [featureId]: [...current, permissionId] };
      }
    });
  };

  const handleSubmit = () => {
    if (groupName === "") {
      toast.error("Please fill Group name !!")
      return;
    }
    if (
      !selected ||
      Object.keys(selected).length === 0 || // feature hi nahi hai
      Object.values(selected).every((perms) => perms.length === 0) // feature hai but koi permission nahi
    ) {
      toast.error("Please select at least one Permission!");
      return; // ❌ stop submission
    }

    const payload = {
      name: groupName,
      featureRequests: Object.keys(selected).map((fid) => ({
        featureId: parseInt(fid),
        permissionRequests: selected[fid].map((pid) => ({ permissionId: pid })),
      })),
    };
    console.log("payload", payload)
    setLoading(true);
    const request = editMode
      ? privateAxios.put(`admin/group-maps/${editGroupId}`, payload)
      : privateAxios.post('admin/group-maps', payload);

    request.then(() => {
      toast.success(editMode ? 'Group Map Updated' : 'Group Map Created');
      resetForm();
      fetchGroupMaps();
    }).catch((error) => { toast.error(error?.response?.data?.response || 'Failed to save group map'); console.log("group error", error) }).finally(() => setLoading(false));
  };

  const resetForm = () => {
    setGroupName('');
    setEmployeeIds([])
    setEditMode(false);
    setEditGroupId(null);
    setOpen(false);
    setSelected({})
    setViewOpen(false)
    setAssignEmployee(false)
  };

  const handleEdit = (groupMap) => {
    setGroupName(groupMap?.groupName);

    const editSelected = {};

    groupMap.groupPermissions?.forEach((gp) => {
      const fid = gp.feature?.id;
      const pid = gp.permission?.id;

      // feature ke liye array initialize
      if (!editSelected[fid]) {
        editSelected[fid] = [];
      }

      // permissionId push karo
      editSelected[fid].push(pid);
    });

    setSelected(editSelected); // ✅ UI prefill hoga

    setEditMode(true);
    setEditGroupId(groupMap.id);
    setOpen(true);
  };


  const handleDelete = (id) => {
    privateAxios.delete(`admin/group-maps/${id}`, { headers })
      .then(() => {
        fetchGroupMaps();
        toast.success('Group Map Deleted !!');
        setOpenConfirm(false);
        setDeleteId(null);
      }).catch((error) => { toast.error('Failed to delete group !!'); console.log("error", error) });
  };

  const handleEmployeeCheckboxChange = (empId) => {
    setEmployeeIds((prev) => {
      if (prev.includes(empId)) {
        // agar already selected hai to remove karo
        return prev.filter((id) => id !== empId);
      } else {
        // otherwise add karo
        return [...prev, empId];
      }
    });
  };
  const handleAssignEmployee = () => {
    if (!employeeIds || employeeIds.length === 0) {
      toast.error("Please select at least one Employee!");
      return; // ❌ stop submission
    }
    const payload = { groupId: selectedGroup.id, employeeIds: employeeIds };
    setLoading(true);
    const request = privateAxios.put(`admin/group-maps/assign`, payload)
    request.then(() => {
      toast.success('Employees Assign on group succesfully!!');
      fetchGroupMaps();
      resetForm();
    }).catch((error) => { toast.error(error?.response?.data?.response || 'Failed to Assign Employees'); console.log("group error", error) }).finally(() => setLoading(false));
  };

  useEffect(() => {
    if (assignEmployee && selectedGroup?.assignEmployees) {
      setEmployeeIds(selectedGroup.assignEmployees.map((e) => e.id));
    }
  }, [assignEmployee, selectedGroup]);

  const writeAction = PermissionService.has({ category: "Admin", page: "Add Groups", type: "WRITE" });

  const columns = [
    {
      field: "serialNo",
      headerName: "S.No.",
      width: 80,
      sortable: false,
      renderCell: (params) => params.api.getAllRowIds().indexOf(params.id) + 1
    },
    {
      field: 'name',
      headerName: 'Group Name',
      flex: 1,
    },
    {
      field: 'employeeNameAndEmail',
      headerName: 'Employees',
      flex: 1,
    },
    {
      field: 'viewPermissions',
      headerName: 'View Permissions',
      width: 150,
      sortable: false,
      renderCell: (params) => (
        <IconButton
          size="small"
          color="primary"
          sx={{ p: 0, m: 0, cursor: "pointer" }}
          onClick={() => {
            setSelectedGroup(params.row.original);
            setViewOpen(true);
          }}>
          <Visibility fontSize="small" sx={{ fontSize: 18, cursor: "pointer" }} />
        </IconButton>
      ),
    },
    ...(writeAction ? [
      {
        field: 'assignEmployee',
        headerName: 'Assign Employees',
        width: 150,
        sortable: false,
        renderCell: (params) => (
          <IconButton
            size="small"
            color="primary"
            sx={{ p: 0, m: 0, cursor: "pointer" }}
            onClick={() => {
              setSelectedGroup(params.row.original);
              setAssignEmployee(true)
              setViewOpen(true);
            }}>
            <GroupAddIcon fontSize="small" sx={{ fontSize: 18, cursor: "pointer" }} />
          </IconButton>
        ),
      },
      {
        field: 'actions',
        headerName: 'Actions',
        width: 130,
        sortable: false,
        renderCell: (params) => (
          <Box display="flex" gap={0} sx={{ p: 0, m: 0, minHeight: 0 }}>
            <Tooltip title="Edit">
              <IconButton
                size="small"
                // disabled={params.row.employees}
                sx={{ p: 0, m: 0, minWidth: 24, minHeight: 24, cursor: "pointer" }}
                onClick={() => handleEdit(params.row.original)}
              >
                <Edit fontSize="small" sx={{ fontSize: 15, cursor: "pointer" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Delete">
              <IconButton
                color="error"
                size="small"
                // disabled={params.row.employees}
                sx={{ p: 0, m: 0, minWidth: 24, minHeight: 24, cursor: "pointer" }}
                onClick={() => {
                  setDeleteId(params.row.original.id);
                  setOpenConfirm(true);
                }}
              >
                <Delete fontSize="small" sx={{ fontSize: 15, cursor: "pointer" }} />
              </IconButton>
            </Tooltip>
          </Box>
        ),
      },
    ] : []),
  ];

  const rows = groupMaps.map((g, index) => ({
    id: g.id,
    name: g.groupName || "----",
    employeeNameAndEmail: g.assignEmployees?.map(e => e.name + " (" + e.email + ")")?.join(", ") || '----',
    employeeName: g.assignEmployees?.map(e => e.name)?.join(", ") || '----',
    employeeEmail: g.assignEmployees?.map(e => e.email)?.join(", ") || '----',
    permissions: g.groupPermissions?.map(gp => gp.feature?.pageName + " (" + gp.permissionName + ")")?.join(", ") || '----',
    original: g, // pass full object for edit/view handlers
    employees: g.assignEmployees,
  }));


  const filteredRows = rows.filter(row => {
    const query = searchText.toLowerCase();
    return (
      row.name?.toLowerCase().includes(query) ||
      row.employeeName?.toLowerCase().includes(query) ||
      row.employeeEmail?.toLowerCase().includes(query)
    );
  });

    const getExportData = () => getSelectedExportRows(filteredRows, selectedRowIds);

  const handleExportCSV = () => {
    const exportRows = getExportData();
    if (!exportRows) return;
    const csvContent = exportRows.map((row, index) => [index + 1,
    row.name, row.employeeNameAndEmail, row.permissions
    ].join(',')).join('\n');
    const headers = ['S.No.', 'Name', 'Employees', 'Permissions'].join(',');
    const csv = `${headers}\n${csvContent}`;
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'groupMaps.csv';
    link.click();
  };
  const handleExportPDF = () => {
    const exportRows = getExportData();
    if (!exportRows) return;
    const doc = new jsPDF();
    doc.setFontSize(12);
    doc.text("Group Map List", 14, 15);
    const tableColumn = ['S.No.', 'Name', 'Employees', 'Permissions'];
    const tableRows = exportRows.map((row, index) => [index + 1, row.name, row.employeeNameAndEmail, row.permissions]);
    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 20,
      theme: 'striped',
      headStyles: {
        fillColor: [37, 99, 235], // Tailwind blue-600 (RGB: 37,99,235)
        textColor: [255, 255, 255], // white text
        halign: 'left',
      },
      styles: { fontSize: 8, cellPadding: 1, overflow: 'linebreak' },
    });
    doc.save('groupMaps.pdf');
  };
  const handlePrint = () => {
    const exportRows = getExportData();
    if (!exportRows) return;
    const printWindow = window.open('', '_blank');
    const headers = ['S.No.', 'Name', 'Employees', 'Permissions'];
    const tableContent = exportRows.map((row, index) => [index + 1, row.name, row.employeeNameAndEmail, row.permissions]);
    const html = `
        <html>
          <head>
            <title>Group Map List</title>
            <style>
              table { border-collapse: collapse; width: 100%; }
              th, td { border: 1px solid black; padding: 8px; text-align: left; }
              th {background: #449AEF;
                color: white;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact; }
              tr:nth-child(even) { background-color: #f5f5f5; }
            </style>
          </head>
          <body>
            <h2>Group Map List</h2>
            <table>
              <thead>
                <tr>
                  ${headers.map(header => `<th>${header}</th>`).join('')}
                </tr>
              </thead>
              <tbody>
                ${tableContent.map(row => `
                  <tr>
                    ${row.map(cell => `<td>${cell}</td>`).join('')}
                  </tr>
                `).join('')}
              </tbody>
            </table>
          </body>
        </html>
      `;
    printWindow.document.write(html);
    printWindow.document.close();
    printWindow.print();
  };



  return (
    <Box sx={{ maxWidth: 1200, mx: 'auto' }}>
      <Card className="p-4" sx={{ borderRadius: 2, boxShadow: 1, }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <CardHeader
            title={<Typography variant="h6" className="text-gray-700">GROUP MAPS</Typography>}
            sx={{ p: 0 }}
          />
          {writeAction && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <IconButton
                sx={{
                  background: "linear-gradient(90deg, #449AEF 0%, #f87171 100%)",
                  color: "#fff",
                  boxShadow: "0 2px 8px rgba(239,68,68,0.15)",
                  transition: "all 0.2s",
                  "&:hover": {
                    background: "linear-gradient(90deg, #f87171 0%, #449AEF 100%)",
                    boxShadow: "0 4px 16px rgba(239,68,68,0.25)",
                    transform: "scale(1.02)",
                  },
                  cursor: "pointer",
                  p: 1,
                  borderRadius: '50%',
                }}
                onClick={() => setOpen(true)}
              >
                <Add />
              </IconButton>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 700, color: "#449AEF", fontSize: "1.2rem", letterSpacing: 0.2 }}
              >
                Add Permission
              </Typography>
            </Box>
          )}
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', mb: 2 }}>
          <Box sx={{ display: 'flex', gap: 1.5, mb: { xs: 2, sm: 0 } }}>
            <Button
              variant="contained"
              startIcon={<FileDownload />}
              onClick={handleExportCSV}
              sx={{
                background: 'linear-gradient(90deg, #592545 0%, #a63f7b 100%)',
                color: '#fff',
                fontWeight: 600,
                fontSize: '0.85rem',
                borderRadius: '6px',
                px: 2,
                py: 0.8,
                transition: 'all 0.2s',
                '&:hover': {
                  background: 'linear-gradient(90deg, #a63f7b 0%, #592545 100%)',
                  boxShadow: '0 4px 12px rgba(89,37,69,0.2)',
                  transform: 'scale(1.02)',
                },
                cursor: 'pointer',
                width: { xs: '100%', sm: 'auto' },
              }}
            >
              Export CSV
            </Button>
            <Button
              variant="contained"
              startIcon={<PictureAsPdf />}
              onClick={handleExportPDF}
              sx={{
                background: 'linear-gradient(90deg, #592545 0%, #a63f7b 100%)',
                color: '#fff',
                fontWeight: 600,
                fontSize: '0.85rem',
                borderRadius: '6px',
                px: 2,
                py: 0.8,
                transition: 'all 0.2s',
                '&:hover': {
                  background: 'linear-gradient(90deg, #a63f7b 0%, #592545 100%)',
                  boxShadow: '0 4px 12px rgba(89,37,69,0.2)',
                  transform: 'scale(1.02)',
                },
                cursor: 'pointer',
                width: { xs: '100%', sm: 'auto' },
              }}
            >
              Export PDF
            </Button>
            <Button
              variant="contained"
              startIcon={<Print />}
              onClick={handlePrint}
              sx={{
                background: 'linear-gradient(90deg, #592545 0%, #a63f7b 100%)',
                color: '#fff',
                fontWeight: 600,
                fontSize: '0.85rem',
                borderRadius: '6px',
                px: 2,
                py: 0.8,
                transition: 'all 0.2s',
                '&:hover': {
                  background: 'linear-gradient(90deg, #a63f7b 0%, #592545 100%)',
                  boxShadow: '0 4px 12px rgba(89,37,69,0.2)',
                  transform: 'scale(1.02)',
                },
                cursor: 'pointer',
                width: { xs: '100%', sm: 'auto' },
              }}
            >
              Print
            </Button>
          </Box>
          <Box>
            <TextField
              label="Search Groups"
              variant="outlined"
              size="small"
              value={searchText}
              onChange={e => setSearchText(e.target.value)}
              sx={{ width: { xs: '100%', sm: '300px' } }}
            />
          </Box>
        </Box>
        <Box sx={{ height: "100%", width: "100%" }}>
          <DataGrid
            rows={filteredRows}
            columns={columns}
            pagination
            initialState={{
              pagination: { paginationModel: { pageSize: 10, page: 0 } },
            }}
            pageSizeOptions={[10, 25, 50, 75, 100]}
            getRowId={(row) => row?.id}
            checkboxSelection
            onRowSelectionModelChange={(ids) => setSelectedRowIds(ids)}
            rowSelectionModel={selectedRowIds}
            disableSelectionOnClick
            density="compact"
            experimentalFeatures={{ virtualization: true }}
            loading={groupsLoading}
            autoHeight={true}
            sx={{
              borderRadius: 2,
              fontSize: "0.8rem",
              "& .MuiDataGrid-cell": {
                fontSize: "0.8rem",
                border: "1px solid rgb(204, 201, 201)",
                minHeight: "36px !important",
                height: "36px !important",
                lineHeight: "1.2",
                paddingTop: "4px",
                paddingBottom: "4px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              },
              "& .MuiDataGrid-columnHeader": {
                backgroundColor: "#449AEF",
                color: "#fff",
                fontWeight: "bold",
                fontSize: "0.8rem",
                padding: "8px",
                border: "1px solid rgb(204, 201, 201)",
                minHeight: "36px !important",
                height: "36px !important",
                lineHeight: "1.2",
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                fontSize: "0.8rem",
                fontWeight: 600,
              },
              "& .MuiDataGrid-row": {
                maxHeight: "36px !important",
                minHeight: "36px !important",
              },
              "& .MuiDataGrid-row:nth-of-type(odd)": {
                backgroundColor: "#f5f5f5",
              },
              "& .MuiDataGrid-row:nth-of-type(even)": {
                backgroundColor: "#ffffff",
              },
              "& .MuiDataGrid-row:hover": {
                backgroundColor: "#f5f5f5",
              },
            }}
          />
        </Box>
      </Card>
      {/* Add/Edit Dialog */}
      <Dialog open={open} onClose={() => {
        setOpen(false);
        resetForm();  // this already clears editMode etc.
      }} fullWidth maxWidth="md">
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography variant="h6">
            {editMode ? "Edit Permission" : "Add Permission"}
          </Typography>

          <Box sx={{ display: 'flex', gap: 1 }}>

            <Button
              fullWidth
              variant="contained"
              onClick={handleSubmit}
              disabled={loading}
              sx={{ position: 'relative', height: 40 }}
            >
              {loading ? (
                <CircularProgress
                  size={24}
                  sx={{
                    color: 'white',
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    marginTop: '-12px',
                    marginLeft: '-12px',
                  }}
                />
              ) : (
                editMode ? "Update" : "Submit"
              )}
            </Button>

            <Button
              fullWidth
              variant="outlined"
              onClick={() => {
                setOpen(false);
                resetForm();
              }} // ⬅️ You can replace this with your own cancel handler
              disabled={loading}
              sx={{ position: 'relative', height: 40 }}
            >
              Cancel
            </Button>
          </Box>
        </DialogTitle>

        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} >
              <TextField
                label="Group Name"
                fullWidth
                size="small"
                value={groupName}
                onChange={(e) => setGroupName(e.target.value)}
                sx={{ mb: 1 }}
              />
            </Grid>
          </Grid>
          <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
            {Object.entries(
              categories.reduce((acc, feat) => {
                acc[feat.category] = acc[feat.category] || [];
                acc[feat.category].push(feat);
                return acc;
              }, {})
            ).map(([category, feats]) => (
              <div
                key={category}
                style={{
                  display: "flex",
                  backgroundColor: "#fff",
                  border: "1px solid #e0e0e0",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                  overflow: "hidden",
                }}
              >
                {/* Left Category Panel */}
                <div
                  style={{
                    minWidth: "180px",
                    backgroundColor: "#fafafa",
                    padding: "8px",
                    fontWeight: 500,
                    borderRight: "1px solid #eee",
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                  }}
                >
                  {category}
                </div>

                {/* Right Features List */}
                <div
                  style={{
                    flex: 1,
                    padding: "0px 8px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {feats.map((feat) => (
                    <div
                      key={feat.id}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        borderBottom: "1px dashed #ddd",
                        padding: "4px 0",
                      }}
                    >
                      <div style={{ fontWeight: 450 }}>{feat.pageName}</div>
                      <div style={{ display: "flex", gap: "12px" }}>
                        {permissions.map((permission) => (
                          <label key={permission.id} style={{ fontSize: "13px" }}>
                            <Checkbox
                              size="small"
                              checked={selected[feat.id]?.includes(permission.id) || false}
                              onChange={() => handleCheckboxChange(feat.id, permission.id)}
                            />
                            {permission?.permissionName}
                          </label>
                        ))}


                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

        </DialogContent>
      </Dialog>

      {/* View Permissions Dialog */}
      <Dialog open={viewOpen} onClose={() => { setViewOpen(false); resetForm(); }} fullWidth maxWidth="md">
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography variant="h6">
            {assignEmployee ? "Assign Employees" : "View Permissions"}
          </Typography>
          <Box sx={{ display: 'flex', gap: 1 }}>

            {assignEmployee && (
              <Button
                fullWidth
                variant="contained"
                onClick={handleAssignEmployee}
                disabled={loading}
                sx={{ position: 'relative', height: 40 }}
              >
                {loading ? (
                  <CircularProgress
                    size={24}
                    sx={{
                      color: 'white',
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      marginTop: '-12px',
                      marginLeft: '-12px',
                    }}
                  />
                ) : (
                  "Assign"
                )}
              </Button>
            )}

            <Button
              fullWidth
              variant="outlined"
              onClick={() => {
                setViewOpen(false);
                resetForm();
              }} // ⬅️ You can replace this with your own cancel handler
              disabled={loading}
              sx={{ position: 'relative', height: 40 }}
            >
              Cancel
            </Button>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} >
              <TextField
                label="Group Name"
                fullWidth
                value={selectedGroup?.groupName}
                disabled
                size="small"
                sx={{ mb: 1 }}
              />
            </Grid>
          </Grid>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            {Object.entries(
              (selectedGroup?.groupPermissions || []).reduce((acc, feat) => {
                acc[feat.feature.category] = acc[feat.feature.category] || [];
                acc[feat.feature.category].push(feat);
                return acc;
              }, {})
            ).map(([category, perms]) => (
              <div
                key={category}
                style={{
                  display: 'flex',
                  backgroundColor: '#fff',
                  border: '1px solid #e0e0e0',
                  borderRadius: '6px',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                  overflow: 'hidden'
                }}
              >
                {/* Left Category Panel */}
                <div
                  style={{
                    minWidth: '180px',
                    backgroundColor: '#fafafa',
                    padding: '8px',
                    fontWeight: 500,
                    borderRight: '1px solid #eee',
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyContent: 'flex-start',
                  }}
                >
                  {category}
                </div>

                {/* Right Features List */}
                <div style={{ flex: 1, padding: '0px 8px', display: 'flex', flexDirection: 'column', gap: '2px' }}>
                  {Object.entries(
                    perms.reduce((acc, feat) => {
                      const page = feat.feature.pageName;
                      acc[page] = acc[page] || [];
                      acc[page].push(feat.permission.permissionName);
                      return acc;
                    }, {})
                  ).map(([pageName, permissions]) => (
                    <div
                      key={pageName}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        borderBottom: "1px dashed #ddd",
                      }}
                    >
                      <div style={{ fontWeight: 450 }}>{pageName}</div>
                      <div>
                        <label style={{ marginRight: "16px", fontSize: "13px" }}>
                          <Checkbox
                            size="small"
                            checked={permissions.some(p => p.toUpperCase() === "READ")}
                          />
                          READ
                        </label>
                        <label style={{ fontSize: "13px" }}>
                          <Checkbox
                            size="small"
                            checked={permissions.some(p => p.toUpperCase() === "WRITE")}
                          />
                          WRITE
                        </label>
                      </div>
                    </div>
                  ))}

                </div>
              </div>
            ))}
          </div>
          {!assignEmployee && (
            <Grid container spacing={2} mt={1}>
              {selectedGroup?.assignEmployees?.map((emp, index) => (
                <Grid item xs={12} sm={6} md={4} key={emp.id || index}>
                  <TextField
                    label={`Employee ${index + 1}`}   // ✅ Dynamic label
                    fullWidth
                    value={`${emp?.name} (${emp?.email})`} // ✅ Name + Email in one string
                    disabled
                    size="small"
                  />
                </Grid>
              ))}
            </Grid>
          )}

          {assignEmployee && (
            <Grid container >
              {users?.map((emp) => (
                <Grid item xs={12} sm={6} md={4} key={emp.id}>
                  <Box display="flex" alignItems="center">
                    <Checkbox
                      size="small"
                      checked={employeeIds.includes(emp.id)}
                      onChange={() => handleEmployeeCheckboxChange(emp.id)}
                    />
                    <Typography variant="body2">
                      {emp?.name} ({emp?.email})
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          )}
        </DialogContent>
      </Dialog>
      {/* delete dialog box */}
      <Dialog open={openConfirm} onClose={() => setOpenConfirm(false)}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          Are you sure you want to delete this Permission?
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirm(false)} color="primary">
            Cancel
          </Button>
          <Button
            onClick={() => {
              handleDelete(deleteId);   // Call your delete function   
            }}
            color="error"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

    </Box>
  );
};

export default AddGroupMap;
